/* storybook-check-ignore */
/* eslint-disable jsdoc/check-alignment */
/* check-alignment clashes with prettier in jsx */
import { Flex, Image, ImageProps, Text } from '@opendoor/bricks/core';

const getLogoDimensionStyles = (
  width?: ImageProps['width'],
  height?: ImageProps['height'],
): Partial<ImageProps> => {
  if (width && height) {
    return {
      width,
      height,
    };
  }

  return { maxWidth: '120px' };
};

const LegalFooter: React.FC<{
  legalText?: string | null;
  logoUrl?: string | null;
  logoRequiredDimensions?: {
    width: number;
    height: number;
  } | null;
  detailPageLogo?: boolean | null;
  detailPageLegalText?: boolean | null;
}> = (props) => {
  return (
    <Flex flexDirection="column" gap="6">
      <Flex flexDirection="column">
        {/**
         * Dangerously set inner html is okay here, since the legal text comes from the server as html (and can contain links)
         * https://github.com/opendoor-labs/code/blob/master/js/packages/athena/src/property/resolvers/helpers/constants/mlsConfig.ts
         * This would be an ideal place to connect to contentful
         * and use the "rich text" type
         * This could be a place for an xss injection, but it is not
         * user submitted data, it comes from athena and is controlled
         */}
        {props.detailPageLegalText && props.legalText && (
          <Text
            fontSize="s00"
            color="neutrals90"
            dangerouslySetInnerHTML={{ __html: props.legalText }}
          ></Text>
        )}
        {props.detailPageLogo && props.logoUrl && (
          <Image
            my={6}
            src={props.logoUrl}
            {...getLogoDimensionStyles(
              props.logoRequiredDimensions?.width,
              props.logoRequiredDimensions?.height,
            )}
            alt={''}
            loading="lazy"
          />
        )}
        <Text fontSize={'s00'} color="neutrals90">
          School rankings provided by Niche. School information is to be used as reference only. To
          verify enrollment eligibility for a specific property, contact the school or the local
          school board.
        </Text>
      </Flex>
    </Flex>
  );
};

export default LegalFooter;
